"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupOrderList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _ProductList = require("../ProductList");
var _LocaleProvider = require("../LocaleProvider");
var _Popup = require("../Popup");
var _constants = require("../../utils/constants");
var _bodyScrollLock = require("body-scroll-lock");
var _Tabs = require("../Tabs");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

// for pc seller bot
var PopupOrderList = function PopupOrderList(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    onLoadMore = props.onLoadMore,
    onClose = props.onClose,
    onSelectClick = props.onSelectClick,
    defaultSelected = props.defaultSelected,
    selectOrderText = props.selectOrderText,
    _props$showMask = props.showMask,
    showMask = _props$showMask === void 0 ? true : _props$showMask,
    _props$showBoxShadow = props.showBoxShadow,
    showBoxShadow = _props$showBoxShadow === void 0 ? false : _props$showBoxShadow,
    itemText = props.itemText,
    itemsText = props.itemsText,
    panelTitleText = props.panelTitleText,
    _props$closeWhenClick = props.closeWhenClickOutside,
    closeWhenClickOutside = _props$closeWhenClick === void 0 ? false : _props$closeWhenClick,
    showUserTypeTab = props.showUserTypeTab,
    container = props.container,
    userTypes = props.userTypes,
    className = props.className,
    showStillNotFound = props.showStillNotFound,
    onClickStillNotFound = props.onClickStillNotFound,
    stillNotFoundButtonText = props.stillNotFoundButtonText,
    componentTrackingData = props.componentTrackingData;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('popup-order-list');
  var sellerTitles = _constants.SELLER_TITLES.map(function (item) {
    return {
      name: trans(item.name),
      type: item.type
    };
  });
  var scrollTop = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      var targetElement = document.querySelector('.ChatbotUI-tabs');
      if (active) {
        targetElement && (0, _bodyScrollLock.disableBodyScroll)(targetElement, {
          allowTouchMove: function allowTouchMove() {
            return true;
          }
        });
        scrollTop.current = document.documentElement.scrollTop;
        document.body.style.height = '101vh';
        document.documentElement.scrollTop = scrollTop.current || 1;
      } else {
        targetElement && (0, _bodyScrollLock.enableBodyScroll)(targetElement);
        document.body.style.height = 'inherit';
        document.documentElement.scrollTop = scrollTop.current || 0;
      }
    }, 0);
    return function () {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    };
  }, [active]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: panelTitleText || trans(_constants.SELLER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    showMask: showMask,
    showBoxShadow: showBoxShadow,
    active: active,
    onClose: onClose,
    closeWhenClickOutside: closeWhenClickOutside,
    className: className,
    titleClassName: "".concat(prefixCls, "-popup__title"),
    contentClassName: "".concat(prefixCls, "-popup__content"),
    container: container
  }, /*#__PURE__*/_react.default.createElement(_ProductList.ProductListTabs, {
    tabs: sellerTitles,
    tabsType: _Tabs.Type.underscore,
    onLoadMore: onLoadMore,
    showOrderId: true,
    showScrollIcon: true // showDetailButton={showDetailButton}
    ,

    onButtonClick: onSelectClick // onDetailButtonClick={onDetailButtonClick}
    ,

    showUserTypeTab: showUserTypeTab,
    defaultSelected: defaultSelected,
    selectOrderText: selectOrderText,
    itemText: itemText,
    itemsText: itemsText,
    userTypes: userTypes,
    showStillNotFound: showStillNotFound,
    onClickStillNotFound: onClickStillNotFound,
    stillNotFoundButtonText: stillNotFoundButtonText,
    componentTrackingData: componentTrackingData
  })));
};
exports.PopupOrderList = PopupOrderList;